import type StudyDocumentModel from '../../../models/StudyDocumentModel';
import { requestAndParse, requestSuccessful } from '../request';

const getParticipantDocuments = async (participantId?: string) => {
    const route = 'admin/get-participant-documents';
    const payload = { participantId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const documents =
        (response.body?.documents as StudyDocumentModel[]) ??
        ([] as StudyDocumentModel[]);

    return { success, documents };
};

export default getParticipantDocuments;
